// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3nkoU","errorLogs":"styles_errorLogs__3DvwQ"};